module.exports = __webpack_public_path__ + "Simple-Line-Icons.0cb0b9c589c0624c9c78.woff2";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module chunks = styles